const ROLE_ADMIN = "ROLE_ADMIN";

function parseJwtPayload(token: string): Record<string, any> | null {
  try {
    const base64 = token.split(".")[1];
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

export function getStoredToken(): string | null {
  return localStorage.getItem("adminAuthToken");
}

export function getStoredRefreshToken(): string | null {
  return localStorage.getItem("adminRefreshToken");
}

export function saveTokens(accessToken: string, refreshToken: string): void {
  localStorage.setItem("adminAuthToken", accessToken);
  localStorage.setItem("adminRefreshToken", refreshToken);
}

export function clearTokens(): void {
  localStorage.removeItem("adminAuthToken");
  localStorage.removeItem("adminRefreshToken");
  localStorage.removeItem("adminPreAuthToken");
}

export function isAuthenticated(): boolean {
  const token = getStoredToken();
  if (!token) return false;
  const payload = parseJwtPayload(token);
  if (!payload) return false;
  if (payload.exp && Date.now() / 1000 > payload.exp) {
    clearTokens();
    return false;
  }
  return true;
}

export function isSuperAdmin(): boolean {
  const token = getStoredToken();
  if (!token) return false;
  const payload = parseJwtPayload(token);
  if (!payload) return false;
  const roles: string[] = payload.roles || [];
  return roles.includes(ROLE_ADMIN);
}

export function getCurrentUserEmail(): string {
  const token = getStoredToken();
  if (!token) return "";
  const payload = parseJwtPayload(token);
  return payload?.email || payload?.sub || "";
}
